export const buildEvaluateMeasureParameters = (
    periodStart: string,
    periodEnd: string,
    serviceId?: string
) => {
    const parameter: any[] = [
        {
            name: "periodStart",
            valueDate: periodStart
        },
        {
            name: "periodEnd",
            valueDate: periodEnd
        }
    ];

    if (serviceId) {
        parameter.push({
            name: "parameters",
            resource: {
                resourceType: "Parameters",
                parameter: [
                    {
                        name: "serviceId",
                        valueString: serviceId
                    }
                ]
            }
        });
    }

    return {
        resourceType: "Parameters",
        parameter
    };
};